export const groupSubmissionsByRenewalHistory = (submissions, renewalData) => {
  if (!renewalData?.renewalMap || !renewalData?.submissions) {
    return submissions.map((s) => ({
      groupName: s.insured,
      submissions: [s],
      isRenewalGroup: false,
    }));
  }

  // Build a lookup so we prefer the enriched display submissions over the
  // raw objects stored in renewalData.submissions.
  const displayById = new Map(submissions.map((s) => [s.submissionId, s]));

  const processedSubmissions = new Set();
  const groups = [];

  submissions.forEach((submission) => {
    if (processedSubmissions.has(submission.submissionId)) {
      return;
    }

    let rootSubmissionId = submission.submissionId;
    const priorWalkSeen = new Set();

    while (renewalData.renewalMap[rootSubmissionId]?.prior) {
      const priorSubmissionId = renewalData.renewalMap[rootSubmissionId].prior;

      if (priorWalkSeen.has(priorSubmissionId)) {
        break;
      }

      priorWalkSeen.add(rootSubmissionId);

      if (renewalData.submissions[priorSubmissionId]) {
        rootSubmissionId = priorSubmissionId;
      } else {
        break;
      }
    }

    const renewalChain = [];
    const submissionQueue = [rootSubmissionId];
    const renewalWalkSeen = new Set();

    while (submissionQueue.length > 0) {
      const currentSubmissionId = submissionQueue.shift();

      if (renewalWalkSeen.has(currentSubmissionId)) {
        continue;
      }
      renewalWalkSeen.add(currentSubmissionId);

      if (renewalData.submissions[currentSubmissionId]) {
        // Prefer the enriched submission from the display set over the raw
        // renewal-data copy so that client-side enrichments (e.g.
        // primaryUnderwriterLocation) are preserved in the grouped view.
        const enriched = displayById.get(currentSubmissionId);
        renewalChain.push(
          enriched ?? renewalData.submissions[currentSubmissionId]
        );
        processedSubmissions.add(currentSubmissionId);
      }

      const renewals =
        renewalData.renewalMap[currentSubmissionId]?.renewals || [];
      submissionQueue.push(...renewals);
    }
    if (renewalChain.length > 0) {
      renewalChain.sort(
        (a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate)
      );

      groups.push({
        submissions: renewalChain,
        isRenewalGroup: renewalChain.length > 1,
      });
    }
  });

  submissions.forEach((submission) => {
    if (!processedSubmissions.has(submission.submissionId)) {
      groups.push({
        submissions: [submission],
        isRenewalGroup: false,
      });
    }
  });

  return groups;
};
